export const getBusinessesUrl = () => '/agency/businesses';

export const getBusinessUrl = (id: number) => `/agency/businesses/${id}`;

export const getAgencyPerformanceUrl = () => '/agency/usage';

export const getAgencyUsageBreakdownUrl = () => '/agency/usage/breakdown';

export const getAgencyUsageAnalyticsUrl = () => '/agency/usage/analytics';
